// extracted by mini-css-extract-plugin
module.exports = {"csr-C":"C_csr-C__a5gFX"};